import _mergeJSXProps2 from "@vue/babel-helper-vue-jsx-merge-props";
import _mergeJSXProps from "@vue/babel-helper-vue-jsx-merge-props";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

import { buildComponentName } from '../utils';
import { VirtualList, AutoSizer } from './virtual-list';
import TreeNode from './virtualTreeNode';
import Tree from './tree';
export default {
  name: buildComponentName('VirtualTree'),
  extends: Tree,
  props: {
    size: {
      type: Number,
      // 每个item的高度
      default: 32
    },
    viewCount: {
      type: Number,
      // 在虚拟列表窗口中，展示item的个数
      default: 30
    },
    bench: {
      type: Number,
      // 待展示节点数，默认与viewCount一致
      default: 0
    },
    pagemode: {
      type: Boolean,
      // 是否使用窗口页面的滚动
      default: false
    },
    autoHeight: {
      type: Boolean,
      // 是否高度自适应
      default: false
    },
    scrollelement: {
      // 使用虚拟列滚动的父元素
      type: typeof window === 'undefined' ? Object : HTMLElement,
      default: null
    },
    className: {
      // 自定义用于virtual-list的样式名
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      flattenedIndexCache: {}
    };
  },
  computed: {
    mapOfFlattenedTree: function mapOfFlattenedTree() {
      var nodes = this.nodes,
          convertTreeToList = this.convertTreeToList;
      var flattenedTreeNodes = {};
      nodes.forEach(function (node) {
        flattenedTreeNodes[node.key] = convertTreeToList(node);
      });
      return flattenedTreeNodes;
    }
  },
  methods: {
    setChildNodeCheckbox: function setChildNodeCheckbox(node, checked) {
      // 该方法是对store.js中的方法重写，优化复选框，对子节点的操作时间
      var _this$treeStore = this.treeStore,
          checkedKeys = _this$treeStore.checkedKeys,
          halfCheckedKeys = _this$treeStore.halfCheckedKeys,
          updateStoreHalfCheckedKeys = this.updateStoreHalfCheckedKeys,
          updateStoreCheckedKeys = this.updateStoreCheckedKeys;
      var children = node.children;
      var nNode = node;
      var stack = [];

      if (children) {
        stack = _toConsumableArray(children);

        if (children.every(function (item) {
          return item.isDisabled || item.disableCheckbox;
        })) {
          nNode.childCheckState = 0;
        } else {
          nNode.childCheckState = checked ? 2 : 0;
        }
      } else {
        nNode.childCheckState = -1; // 没有子节点
      }

      var childKeys = [];
      var childHalfKeys = [];

      while (stack.length) {
        var childNode = stack.pop();

        if (!childNode.isDisabled && !childNode.disableCheckbox) {
          childNode.isChecked = checked; // 关联选中子节点时, 子节点是不可能有halfChecked = true的

          childNode.isHalfChecked = false;
          var key = childNode.key;

          if (checked || !checked && checkedKeys.indexOf(key) > -1) {
            childKeys.push(key);
          }

          if (halfCheckedKeys.indexOf(key) > -1) {
            childHalfKeys.push(key);
          }
        }

        if (childNode.children) {
          stack = [].concat(_toConsumableArray(stack), _toConsumableArray(childNode.children));

          if (childNode.children.every(function (item) {
            return item.isDisabled || item.disableCheckbox;
          })) {
            childNode.childCheckState = 0; // 子节点全部不能选择
          } else {
            childNode.childCheckState = checked ? 2 : 0;
          }
        } else {
          childNode.childCheckState = -1; // 没有子节点
        }
      }

      updateStoreCheckedKeys(childKeys, checked ? 'add' : 'del');

      if (childHalfKeys.length > 0) {
        updateStoreHalfCheckedKeys(childHalfKeys, 'del');
      }
    },
    onNodeExpandBeforeHook: function onNodeExpandBeforeHook(e, node, vm) {
      var autoHeight = this.autoHeight,
          $refs = this.$refs,
          flattenedIndexCache = this.flattenedIndexCache;

      if (autoHeight) {
        var index = flattenedIndexCache[node.key];

        if (index >= 0) {
          $refs.vtl.setChangedIndex(index);
        }
      }
    },
    onNodeDragEndHook: function onNodeDragEndHook() {},
    expandedKeysChanged: function expandedKeysChanged(nVal) {
      if (this.$refs.vtl) {
        this.$refs.vtl.updateToOrigin();
      }
    },
    convertTreeToList: function convertTreeToList(rootNode) {
      var stack = [];
      var childList = [];
      var treeRoot = rootNode;
      treeRoot.level = 0;
      stack.push(treeRoot);

      while (stack.length > 0) {
        var node = stack.pop();
        childList.push(node);

        if (node.children) {
          var children = _toConsumableArray(node.children);

          children.reverse();
          stack = [].concat(_toConsumableArray(stack), _toConsumableArray(children));
        }
      }

      return childList;
    },
    hasAllParentExpandedAndVisible: function hasAllParentExpandedAndVisible(node) {
      var result = true;
      var parentNode = node.parent;
      var visible = true;

      while (parentNode) {
        result = result && parentNode.isExpanded;
        visible = visible && parentNode.isVisible;
        parentNode = parentNode.parent;
      }

      return result && visible;
    },
    getTreeChildrenVNodes: function getTreeChildrenVNodes() {
      var _this = this;

      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          filterNodes = this.filterNodes,
          hasAllParentExpandedAndVisible = this.hasAllParentExpandedAndVisible,
          mapOfFlattenedTree = this.mapOfFlattenedTree,
          autoHeight = this.autoHeight,
          flattenedIndexCache = this.flattenedIndexCache,
          onResize = this.onResize;
      var childrens = [];
      var index = 0;

      if (autoHeight) {
        Object.keys(flattenedIndexCache).forEach(function (key) {
          delete flattenedIndexCache[key];
        });
      }

      filterNodes.forEach(function (firstLevelNode) {
        var nodes = mapOfFlattenedTree[firstLevelNode.key] || [];
        nodes.forEach(function (node) {
          if (!node.isVisible) {
            return;
          }

          if (node.parent && hasAllParentExpandedAndVisible(node) || !node.parent) {
            var innerTreeNode = autoHeight ? h(AutoSizer, {
              "props": _objectSpread({}, {
                unitKey: node.key,
                onResize: onResize
              })
            }, [h(TreeNode, {
              "props": _objectSpread({}, {
                prefixCls: prefixCls,
                node: node
              })
            })]) : h(TreeNode, {
              "props": _objectSpread({}, {
                prefixCls: prefixCls,
                node: node
              })
            });
            childrens.push(innerTreeNode);

            if (autoHeight) {
              _this.flattenedIndexCache[node.key] = index;
              index += 1;
            }
          }
        });
      });
      return childrens;
    },
    onResize: function onResize(key, state) {
      var height = state.height;
      var flattenedIndexCache = this.flattenedIndexCache,
          $refs = this.$refs;
      var index = flattenedIndexCache[key];

      if (index >= 0 && $refs.vtl) {
        $refs.vtl.updateVarCacheItem(index, height);
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var classes = this.classes,
        size = this.size,
        viewCount = this.viewCount,
        getTreeChildrenVNodes = this.getTreeChildrenVNodes,
        prefixCls = this.prefixCls,
        pagemode = this.pagemode,
        bench = this.bench,
        className = this.className,
        scrollelement = this.scrollelement,
        autoHeight = this.autoHeight;
    var childrens = getTreeChildrenVNodes();
    var remain = viewCount;
    var wclass = '';
    Object.keys(classes).forEach(function (classname) {
      if (classes[classname]) {
        wclass = "".concat(wclass, " ").concat(classname);
      }
    });
    wclass = "".concat(wclass, " ").concat(prefixCls, "-virtual ").concat(prefixCls, "-checkbox-virtual ").concat(className);
    var virtualList = h(VirtualList, _mergeJSXProps([{}, {
      ref: 'vtl',
      props: {
        size: size,
        remain: remain,
        bench: bench,
        variable: autoHeight,
        pagemode: pagemode,
        scrollelement: scrollelement,
        wtag: 'ul',
        wclass: wclass
      }
    }]), [childrens]);
    return h("div", _mergeJSXProps2([{}, {
      ref: 'uxTree',
      attrs: {
        unselectable: 'on'
      }
    }]), [virtualList]);
  }
};